var _path, _rect, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.6795 22.2563L49.9358 0.615445C49.5571 0.228902 49.041 0.00785257 48.4999 0H18.9615C13.2971 0 8.70508 4.59199 8.70508 10.2564V69.7436C8.70508 75.408 13.2971 80 18.9615 80H62.0385C67.703 80 72.295 75.408 72.295 69.7436V23.6922C72.2871 23.1513 72.0659 22.6352 71.6795 22.2563ZM50.7564 20.5129V7.17941L65.2179 21.5384H51.7819C51.2756 21.5987 50.8164 21.2371 50.7564 20.7308C50.7477 20.6585 50.7477 20.5853 50.7564 20.5129ZM68.1922 69.7436C68.1922 73.1422 65.4369 75.8974 62.0383 75.8974H18.9615C15.5629 75.8974 12.8077 73.1424 12.8077 69.7436V10.2564C12.8077 6.85784 15.5627 4.10257 18.9615 4.10257H46.6538V20.5129C46.6538 23.3451 48.9497 25.641 51.7819 25.641H68.1922V69.7436Z",
    fill: "white",
    fillOpacity: 0.6
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 61,
    width: 34,
    height: 4,
    rx: 2,
    fill: "white",
    fillOpacity: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 53,
    width: 34,
    height: 4,
    rx: 2,
    fill: "white",
    fillOpacity: 0.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 45,
    width: 34,
    height: 4,
    rx: 2,
    fill: "white",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDock);
export default __webpack_public_path__ + "static/media/dock.82ef0388.svg";
export { ForwardRef as ReactComponent };